export { default as ScrollbarStyle, hideScrollbars, hideScrollbarsOnDesktop, hideScrollbarsOnMobile } from './ScrollbarStyle'
